// extracted by mini-css-extract-plugin
export default {"image":"patient_image__Q-Icc"};